import { forwardRef } from 'react'

import { styled } from 'styled-components'

const Controls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 4px;
`

const Action = styled.button`
  margin-left: 8px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: ${(p) => p.theme.highlight};
  font-size: 12px;

  &:not(:disabled):hover {
    text-decoration: underline;
  }

  &:disabled {
    color: ${(p) => p.theme.mutedText};
  }
`

const SelectBottomControls = forwardRef((props, ref) => {
  const { onClear, canClear, onSelectAll, canSelectAll } = props

  return (
    <Controls>
      {onSelectAll && (
        <Action disabled={!canSelectAll} onClick={onSelectAll}>
          Select All
        </Action>
      )}
      {onClear && (
        <Action disabled={!canClear} onClick={onClear}>
          Clear
        </Action>
      )}
    </Controls>
  )
})

export default SelectBottomControls
